export default "__VITE_ASSET__BBryjkGq__"